<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.companyRequests.title"> </sm-page-header>
  <!-- content -->
  <div class="content">
    <sm-form-builder [formObject]="formObject" class="w-full px-4"></sm-form-builder>
    <div class="flex justify-end gap-2">
      <p-button [label]="'settings.companyRequests.form.actions.approve' | translate" (click)="validateCompany(true)" />
      <p-button [label]="'settings.companyRequests.form.actions.reject' | translate" severity="danger" (click)="validateCompany(false)" />
    </div>
    <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
      <p-tablist>
        <p-tab value="0">{{ 'settings.companyRequests.tabs.users' | translate }}</p-tab>
        <p-tab value="1">{{ 'settings.companyRequests.tabs.activities' | translate }}</p-tab>
        <p-tab value="2">{{ 'settings.companyRequests.tabs.documents' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <sm-company-members [usersSociete]="company.usersSociete"></sm-company-members>
        </p-tabpanel>
        <p-tabpanel value="1">
          <sm-activity [companyId]="id" [activity]="company.activites"></sm-activity>
        </p-tabpanel>
        <p-tabpanel value="2">
          <div class="mt-4 flex flex-col gap-3">
            <div *ngIf="(companyDocs$ | async)?.length === 0" class="text-gray-500 italic p-4 text-center">
              Aucun document disponible.
            </div>
            <div *ngFor="let doc of companyDocs$ | async" 
                 class="flex items-center justify-between p-4 bg-white border border-gray-200 rounded-xl shadow-sm hover:border-primary/50 hover:shadow-md transition-all cursor-pointer group"
                 (click)="openDoc(doc)">
              <div class="flex items-center gap-4">
                <div class="p-3 bg-primary/10 rounded-lg text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                  <i class="pi" [ngClass]="doc.extension === 'pdf' ? 'pi-file-pdf' : 'pi-image'" style="font-size: 1.5rem"></i>
                </div>
                <div>
                  <h4 class="text-gray-800 font-medium m-0">{{ (doc.filename || '') | translate }}</h4>
                  <span class="text-sm text-gray-500 font-semibold uppercase">{{ doc.extension }}</span>
                </div>
              </div>
              <p-button icon="pi pi-eye" [rounded]="true" [text]="true" severity="secondary"></p-button>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

<sm-drawer [drawer]="drawerObj" [(visible)]="showDrawer"></sm-drawer>